module.exports = __webpack_public_path__ + "img/Q12a.26260875.png";